import { createContext, useContext } from "react";
import { usePhantom, shortAddr } from "@/hooks/usePhantom";

const WalletContext = createContext(null);

export const useWallet = () => {
  const ctx = useContext(WalletContext);
  if (!ctx) throw new Error("useWallet must be inside <WalletProvider>");
  return ctx;
};

export function WalletProvider({ children }) {
  const { phantom, connectPhantom, disconnectPhantom } = usePhantom();

  const anyConnected = !!phantom.address;
  const primaryAddress = phantom.address;
  const primaryChain = phantom.address ? "solana" : null;

  const value = {
    phantom,
    anyConnected,
    primaryAddress,
    primaryChain,
    short: shortAddr,
    connectPhantom,
    disconnectPhantom,
  };

  return <WalletContext.Provider value={value}>{children}</WalletContext.Provider>;
}
